import { Component, ElementRef, HostBinding, Inject, OnDestroy, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { FuseConfigService } from '../core/services/config.service';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'fuse-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FuseMainComponent implements OnInit, OnDestroy {
  onSettingsChanged: Subscription;
  fuseSettings: any;
  showLoadingBar: boolean;
  @HostBinding('attr.fuse-layout-mode') layoutMode;

  constructor(
    private router: Router,
    private _renderer: Renderer2,
    private _elementRef: ElementRef,
    private fuseConfig: FuseConfigService,
    private platform: Platform,
    @Inject(DOCUMENT) private document: any
  ) {
    console.log('main component in devvv........')
    this.onSettingsChanged =
      this.fuseConfig.onSettingsChanged
        .subscribe(
          (newSettings) => {
            this.fuseSettings = newSettings;
            this.layoutMode = this.fuseSettings.layout.mode;
          }
        );

    if (this.platform.ANDROID || this.platform.IOS) {
      this.document.body.className += ' is-mobile';
    }
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {

          this.showLoadingBar = true;
        }
        if (event instanceof NavigationEnd) {
          this.showLoadingBar = false;
          // console.log('this.showLoadingBar', this.showLoadingBar);
        }
      });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.onSettingsChanged.unsubscribe();
  }

  addClass(className: string) {
    this._renderer.addClass(this._elementRef.nativeElement, className);
  }

  removeClass(className: string) {
    this._renderer.removeClass(this._elementRef.nativeElement, className);
  }
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/main.component.ts